import { useSize } from 'ahooks'
import { BackTop } from 'antd'
import cls from 'classnames'
import React from 'react'

import { useAppStateQuery } from '@/generated/graphql'

import s from './column-layout.module.less'

interface ColumnLayoutProps {
  header?: React.ReactElement | false | null
  middle?: React.ReactElement | false | null
  right?: React.ReactElement | false | null
  rightWidth?: number | string
  stickyHeader?: boolean
}

export const ColumnLayout: React.FC<ColumnLayoutProps> = ({
  header,
  middle,
  right,
  rightWidth,
  stickyHeader = true,
}) => {
  const [headerHeight, setHeaderHeight] = React.useState(0)
  const headerRef = React.useRef<HTMLDivElement>(null)
  const { data: appStateData } = useAppStateQuery()
  const size = useSize(headerRef)

  React.useLayoutEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(size.height || headerRef.current.offsetHeight)
    }
  }, [size])

  return (
    <>
      {header && (
        <div className={s.header} ref={headerRef} style={{ position: stickyHeader ? 'sticky' : undefined }}>
          {header}
        </div>
      )}
      <div className={s.container}>
        <div className={s.middle}>
          {middle}
          <BackTop className={cls(s.backTop, { [s.backTopHasRight]: !!right })} />
        </div>
        {right && (
          <div
            className={cls(s.right, {
              [s.specialRightWidth]: !appStateData!.appState.showSidebar,
            })}
            style={
              headerRef.current && stickyHeader
                ? { top: headerHeight, height: `calc(100vh - ${headerHeight}px)`, width: rightWidth }
                : undefined
            }
          >
            {right}
          </div>
        )}
      </div>
    </>
  )
}
